var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sgp-page sgp-rosters-edit" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-lg-12" },
        [
          _c("roster-student-form", {
            attrs: {
              project: _vm.projectDetails,
              errors: _vm.formErrors || {},
              form: _vm.formData,
            },
          }),
          _vm._v(" "),
          _vm.isParentEmailsNone
            ? _c("roster-parent-emails", {
                attrs: {
                  project: _vm.projectDetails,
                  errors: _vm.formErrors || {},
                  form: _vm.formData,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("roster-staff-form", {
            attrs: {
              project: _vm.projectDetails,
              errors: _vm.formErrors || {},
              form: _vm.formData,
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 offset-md-2" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-lg btn-block sgp-btn-default",
                staticStyle: { "background-color": "" },
                on: { click: _vm.onUploadSchoolRosters },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.submitText) +
                    "\n                "
                ),
              ]
            ),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }